import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Navbar from './components/Navbar';
import Home from './components/Home';
import Productos from './components/Productos';
import Beneficios from './components/Beneficios';
import Servicios from './components/Servicios';
import Contacto from './components/Contacto';
import Blog from './components/Blog'; // Import the Blog component
import './App.css'; // You'll create this CSS file for styling

function App() {
  return (
    <Router>
      <div  id="home-bg">
        <Navbar />
        <Routes>  {/* Changed Switch to Routes */}
          <Route exact path="/" element={<Home />} />
          <Route path="/consultoria" element={<Servicios />} />
          <Route path="/servicios" element={<Servicios />} />
          <Route path="/productos" element={<Productos />} />
          <Route path="/recetas" element={<Productos />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/beneficios" element={<Beneficios />} />
          <Route path="/contacto" element={<Contacto />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;